import { fetchJSON } from '@bonnet/next/fetch';

const errorObject = {
    error: 'Circuit Breaker for /vehicle-conditioning is open',
};

const options = {
    circuitBreaker: {
        id: 'vehicleConditioning',
        timeout: 10000,
        resetTimeout: 30000,
        fallback: errorObject,
        errorFilter: (error) => error?.status === 401,
        allowWarmUp: true,
    },
    retryOn: [401],
    retries: 1,
    retryDelay: 800,
};

export default (vin) => fetchJSON(
    `/cars-for-sale/vehicle-conditioning/conditioning/vehicles/vin/${vin}/services`,
    { ...options }
);
